/* eslint-disable id-match */
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { BOOKING_CALENDAR_AIRPORTS } from '../../../../brands/default/content/components/deal';
import {
  getCurrentDealLondonAirports,
  addAllLondonObject,
} from '../../../../helpers/booking';
import CustomNativeSelect from '../../../_generic/custom-native-select/CustomNativeSelect';

const BookingCalendarAirports = ({
  deal,
  onAirportChange,
  setCurrentLondonAirports,
}) => {
  const [airports, setAirports] = useState(null);
  const [selectedValue, setSelectedValue] = useState('');

  const { cyfBookingStepTwo } = BOOKING_CALENDAR_AIRPORTS;

  const onChange = (event) => {
    setSelectedValue(event.target.value);
    onAirportChange(event.target.value);
  };

  useEffect(() => {
    if (airports && airports.length > 0) {
      const londonAirports = getCurrentDealLondonAirports(airports);
      if (londonAirports.length >= 2) {
        addAllLondonObject(airports);
        setCurrentLondonAirports(londonAirports);
      }
      setSelectedValue(airports[0].header.slice(0, 3));
      onAirportChange(airports[0].header.slice(0, 3));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [airports]);

  useEffect(() => {
    if (deal.productDisplay.row && deal.productDisplay.row.items) {
      setAirports(deal.productDisplay.row.items);
    }
  }, [deal]);

  return (
    airports && (
      <>
        <CustomNativeSelect
          ariaLabel={cyfBookingStepTwo}
          /* eslint-disable-next-line react/forbid-component-props */
          className="full-width margin"
          id="departure-airport"
          onChange={onChange}
          value={selectedValue}
        >
          {airports.map((airport) => {
            return (
              <option key={airport.id} value={airport.header.slice(0, 3)}>
                {airport.header}
              </option>
            );
          })}
        </CustomNativeSelect>
      </>
    )
  );
};

BookingCalendarAirports.propTypes = {
  deal: PropTypes.object.isRequired,
  onAirportChange: PropTypes.func.isRequired,
  setCurrentLondonAirports: PropTypes.func.isRequired,
};

export default BookingCalendarAirports;
